import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';

import HoverHint from 'lib/struct/hover_hint/HoverHint';
import Field from 'lib/struct/form/fields/Field';
import Select from 'lib/struct/form/Select';
import Checkbox from 'lib/struct/form/Checkbox';
import Link from 'lib/struct/inlines/Link';
import Icon from 'lib/struct/icon/Icon';

import * as MarkupTemplateId from 'settings/constant/MarkupTemplateId';

import styles from './GroupScopeSettingsForm.less';

@observer export default class GroupScopeSettingsForm extends Component {
	render() {
		/** @type {SettingsContext} */
		const context = this.props.context;
		const {scope, header} = this.props;

		const group = context.edited_group;

		const settings = group.getScopeSettings(scope);

		const in_stock_only_label = (
			<HoverHint hint='При активации опции будут выводиться ссылки только на товары, которые есть в наличии'>
				Товары 'В наличии'
			</HoverHint>
		);

		const show_on_primary_product_only_label = (
			<HoverHint hint='При активации опции ссылки на товары группы будут выводиться только на странице основного товара'>
				С основного товара
			</HoverHint>
		);

		return (
			<div className={styles['scope__block']}>
				<h3>{header}</h3>

				<Field label='Выводить'>
					<Checkbox
						checked={settings.is_shown}
						onChange={e => settings.is_shown = e.target.checked}
					/>
				</Field>

				<Field label={in_stock_only_label}>
					<Checkbox
						checked={settings.show_in_stock_only}
						onChange={e => settings.show_in_stock_only = e.target.checked}
					/>
				</Field>

				<Field label={show_on_primary_product_only_label}>
					<Checkbox
						checked={settings.show_on_primary_product_only}
						onChange={e => settings.show_on_primary_product_only = e.target.checked}
					/>
				</Field>

				<Field label='Выводить заголовок группы'>
					<Checkbox
						checked={settings.show_header}
						onChange={e => settings.show_header = e.target.checked}
					/>
				</Field>

				<Field label='Текущий товар всегда первый'>
					<Checkbox
						checked={settings.current_product_first}
						onChange={e => settings.current_product_first = e.target.checked}
					/>
				</Field>

				{
					group.markup_template_id === MarkupTemplateId.PHOTO_GROUP ? (
						<Field
							label='Размер изображения'
							className={styles['scope__image-settings-block']}
						>
							<Select
								options={context.image_size_options}
								value={settings.image_size}
								onChange={e => settings.image_size = e.target.value}
							/>

							<Link className={styles['scope__image-settings-link']} href="?action=settings#/images/" target="_blank">
								<Icon name='add' /> Добавить
							</Link>
						</Field>
					) : (null)
				}
			</div>
		);
	}
}